import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  margin: 0 .5rem;
  max-width: 30vw;
  @media ${devices.phoneS} {
    max-width: auto;
  }
`;

export const InfoText = styled.div`
  margin-bottom: 1rem;
`;

export const WarningMessage = styled.span`
  color: ${({ theme }) => theme.error};
`;

export const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: auto;
  max-height: calc(100vh - 400px);
`;

export const ResponseItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.container};
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.containerOdd};
  }
  & span {
    width: 100%;
    font-size: 14px;
  }
  & > svg {
    height: 18px;
    width: 20px;
    margin-right: 5px;
  }
  &.success {
    & b {
      color: ${({ theme }) => theme.success};
    }
    & > svg {
      fill: ${({ theme }) => theme.success};
    }
  }
  &.error {
    & b {
      color: ${({ theme }) => theme.error};
    }
    & > svg {
      fill: ${({ theme }) => theme.error};
    }
  }
`;
